import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../../assets/animations/education-animation.json';
import { getImagePath } from '../../utils/pathUtils';
import { statsData } from '../../utils/statsData';
import { FaGraduationCap, FaSmile, FaUserTie, FaClock } from 'react-icons/fa';

const Home = () => {

  return (
    <section id="home" className="home-section">
      <div className="home-content container">
        <div className="text-content">
          <h1 className="main-heading">
            <span className="highlight">Master In-Demand Skills</span> with Expert-Led Training
          </h1>
          <p className="sub-heading">
            Join SkillYatra's industry-relevant courses and accelerate your career growth with hands-on learning
            and real-world projects
          </p>
          <div className="cta-buttons">
            <a href="#courses" className="btn primary-btn">
              Explore Courses
              <span className="btn-icon">→</span>
            </a>
            <a href="#contact" className="btn secondary-btn">
              Get Started
              <span className="btn-icon">↓</span>
            </a>
          </div>
          
          <div className="stats-container">
            {statsData.map((stat) => {
              const IconComponent = {
                FaGraduationCap, FaSmile, FaUserTie, FaClock
              }[stat.icon];
              
              return (
                <div key={stat.id} className="stat-card" style={{ '--stat-color': stat.color }}>
                  <div className="stat-icon">
                    <IconComponent />
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">
                      {stat.number}
                      <span className="stat-suffix">{stat.suffix}</span>
                    </span>
                    <span className="stat-label">{stat.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="right-column">
          <div className="live-classes-banner">
            <div className="live-classes-content">
              <div className="live-icon">
                <FaClock />
              </div>
              <div className="live-text">
                <h3>100% Live Interactive Classes</h3>
                <p>Experience real-time learning with daily live sessions. No pre-recorded content - Get your doubts cleared instantly by industry experts!</p>
              </div>
            </div>
          </div>
          
          <div className="animation-container">
            <Lottie 
              path="/assets/lottie/first_animation.json"
              loop={true}
              className="lottie-animation"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
